import { useId } from 'react'

import { StatusBadge } from '../atoms/StatusBadge.tsx'
import type { StatusTone } from '../atoms/statusTone.ts'

import './waitReason.css'

/**
 * 상태 배지 + **그 상태에 머문 이유**(시작 차단 사유). 이유가 없으면 배지만 그린다.
 *
 * 🔴 **비활성 사유 규약(`atoms/disabled.tsx`)과 같은 두 경로로 낸다** — 마우스는 `title` 툴팁,
 *    스크린리더는 `aria-describedby` 가 가리키는 숨김 문장. 화면 본문에 설명을 쓰지 않는다.
 * ⚠ 배지는 버튼이 아니다. 키보드로 사유에 닿게 `tabIndex=0` 만 준다(누를 것은 없다).
 */
export function WaitReasonBadge({
  status,
  label,
  reason,
  size = 'lg',
  tone,
}: {
  status: string
  label: string
  reason: string | undefined
  size?: 'sm' | 'lg' | 'pill'
  /** 옅은 바탕 톤(`statusTone.ts`) — 안 넘기면 종전 모양 */
  tone?: StatusTone | undefined
}) {
  const reasonId = useId()
  const badge = <StatusBadge label={label} size={size} status={status} tone={tone} />
  if (reason === undefined || reason === '') return badge
  return (
    <span aria-describedby={reasonId} className="waitreason" tabIndex={0} title={reason}>
      {badge}
      <span className="a-sr" id={reasonId}>
        {reason}
      </span>
    </span>
  )
}
